var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.billing_data.is_test_period
      ? _c("div", { staticClass: "content__sandbox" }, [
          _c("img", {
            attrs: {
              src: "//static.liqpay.ua/checkout/220402183319/img/sandbox_left.svg",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "content__sandbox__border" }, [
            _vm._v("Тестовый режим"),
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: "//static.liqpay.ua/checkout/220402183319/img/sandbox_right.svg",
            },
          }),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.show_notif
      ? _c(
          "div",
          {
            staticClass:
              "alert border-danger bg-transparent text-secondary fade show billing-alert",
            attrs: { role: "alert" },
          },
          [
            _c(
              "div",
              { staticClass: "d-flex align-items-start" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "flex-1" }, [
                  _c("span", {
                    staticClass: "h5 color-danger-900 d-block mb-1",
                    domProps: { innerHTML: _vm._s(_vm.__t("NEED_PAY")) },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "bill-main-line" }, [
                    _c("span", { staticClass: "bill-usd" }, [
                      _vm._v(_vm._s(_vm.billing_data.costs.usd_cost) + " $"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "bill-eq" }, [_vm._v("=")]),
                    _vm._v(" "),
                    _c("strong", { staticClass: "bill-uah" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("toCurrency")(_vm.billing_data.costs.uah_cost)
                        ) + " ₴"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.hasExtraAdd
                    ? _c(
                        "div",
                        { staticClass: "bill-extra-box mt-2" },
                        [
                          _c("div", { staticClass: "bill-extra-title" }, [
                            _c("i", { staticClass: "fal fa-plus-circle mr-1" }),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.__t("EXTRA_ADD")) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.currentBillExtraList, function (item) {
                            return _c(
                              "div",
                              { key: item.id, staticClass: "bill-extra-row" },
                              [
                                _c("div", { staticClass: "bill-extra-left" }, [
                                  _c(
                                    "span",
                                    { staticClass: "bill-extra-comment" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            item.comment ||
                                              "Додаткове нарахування"
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  item.date
                                    ? _c(
                                        "span",
                                        { staticClass: "bill-extra-date" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.formatDate(item.date)
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "bill-extra-right" }, [
                                  _vm.toNumber(item.usd_cost) !== 0
                                    ? _c(
                                        "span",
                                        { staticClass: "bill-extra-usd" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t+" +
                                              _vm._s(
                                                _vm.moneyUSD(item.usd_cost)
                                              ) +
                                              " $\n\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "bill-extra-uah" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t+" +
                                          _vm._s(_vm.moneyUAH(item.uah_cost)) +
                                          " ₴\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "bill-extra-total" }, [
                            _c("span", [
                              _vm._v("  " + _vm._s(_vm.__t("EXTRA_ADD_TOTAL"))),
                            ]),
                            _vm._v(" "),
                            _c("strong", [
                              _vm.toNumber(_vm.currentBillExtraAdd.usd_cost) !==
                              0
                                ? _c(
                                    "span",
                                    { staticClass: "bill-extra-usd" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t+" +
                                          _vm._s(
                                            _vm.moneyUSD(
                                              _vm.currentBillExtraAdd.usd_cost
                                            )
                                          ) +
                                          " $\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                                +" +
                                  _vm._s(
                                    _vm.moneyUAH(
                                      _vm.currentBillExtraAdd.uah_cost
                                    )
                                  ) +
                                  " ₴\n                            "
                              ),
                            ]),
                          ]),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.billing_data.is_active_pay
                    ? _c("div", { staticClass: "mt-2" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.__t("DISABLED_ONLINE_PAY")) +
                            "\n                    "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.billing_data.is_active_pay
                  ? _c(
                      "div",
                      { staticClass: "billing-actions" },
                      _vm._l(_vm.bills_pay, function (bill) {
                        return _c(
                          "button",
                          {
                            key: bill.bill_id,
                            staticClass:
                              "btn btn-lg btn-outline-success waves-effect waves-themed mb-2",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.go_pay(bill)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "fal fa-download mr-1" }),
                            _vm._v(
                              "\n                        " +
                                _vm._s(bill.date) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("choose_payment"),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-icon mr-3" }, [
      _c("span", { staticClass: "icon-stack icon-stack-md" }, [
        _c("i", { staticClass: "base-7 icon-stack-3x color-danger-900" }),
        _vm._v(" "),
        _c("i", { staticClass: "fal fa-times icon-stack-1x text-white" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }